<template>
  <div>
    <div class='container pt-2 altura-250'>
      <div class='centrado'>
        <img
          class='btn-generico'
          :src='require("@/assets/images/Btn-arrowLeft.gif")'
          :alt="$t('lang.comun.anterior')"
          @click='restarSemana()'
        />
        <div class='calendario-mes'>{{ dateContext.startOf('week').format('D MMM') + ' / ' + dateContext.endOf('week').format('D MMM') + ' (' + dateContext.format('YYYY') + ')'}}</div>
        <img
          class='btn-generico'
          :src='require("@/assets/images/Btn-arrowRight.gif")'
          :alt="$t('lang.comun.anterior')"
          @click='sumarSemana()'
        />
      </div>
      <table class='mt-4' cellspacing='0' cellpadding='0' border=0 width='100%' v-if='jornada.length > 0'>
        <tr>
          <td>
            <table width='100%'>
              <tr>
                <th scope='row' width='12%'>{{ tableTitulos.fecha }}</th>
                <th scope='row' width='10%'>{{ tableTitulos.tipo }}</th>
                <th scope='row' width='10%'>{{ tableTitulos.hora }}</th>
                <th scope='row' width='38%'>{{ tableTitulos.obs }}</th>
                <th scope='row' width='15%'>{{ tableTitulos.parcial }}</th>
                <th scope='row' width='15%'>{{ tableTitulos.total }}</th>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <div style='width:100%; height:200px; overflow:auto;'>
              <table cellspacing='0' cellpadding='1' width='100%'>
                <tr
                  v-for='dia in jornada'
                  :key='dia.diaNum'
                  :class='{ par: dia.diaPar }'
                >
                  <td width='12%'>
                    <small>
                      {{ dia.diaNum }}
                    </small>
                  </td>
                  <td width='10%'>
                    <small v-for='fichaje in dia.fichajes' :key='fichaje.msfichajeid'>
                      {{ fichaje.msfichajetipostr }} <br>
                    </small>
                  </td>
                  <td width='10%'>
                    <small v-for='fichaje in dia.fichajes' :key='fichaje.msfichajeid'>
                      {{ fichaje.msfichajehora }} <br>
                    </small>
                  </td>
                  <td width='38%'>
                    <small v-for='fichaje in dia.fichajes' :key='fichaje.msfichajeid'>
                      {{ fichaje.msfichajeobs }} <br>
                    </small>
                  </td>
                  <td width='15%'>
                    <small v-for='fichaje in dia.fichajes' :key='fichaje.msfichajeid'>
                      {{ fichaje.duracionParcial }} <br>
                    </small>
                  </td>
                  <td width='15%'>
                    <small v-for='fichaje in dia.fichajes' :key='fichaje.msfichajeid'>
                      <b>{{ fichaje.duracionTotal ? fichaje.duracionTotal : '' }}</b> <br>
                    </small>
                  </td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
      </table>
      <div class='centrado pt-4' v-else>
        {{ this.$t('lang.comun.sinregistros') }}
      </div>
    </div>
  </div>
</template>
<script>
import { FichajeApiService } from '@/api/FichajeApiService'
import { Util } from '@/api/Util'
import BRow from 'bootstrap-vue/es/components/layout/row'
import BCol from 'bootstrap-vue/es/components/layout/col'
import Const from '@/util/Const'

const fichajeApiService = new FichajeApiService()
const util = new Util()
const moment = require('moment')

export default {
  data () {
    return {
      today: '',
      dateContext: '',
      lang: sessionStorage.getItem('lang'),
      vacacion: [],
      calendarioLaboral: [],
      fichaje: [],
      opuid: '',
      duracionJornada: 25200,
      diasArray: [
        this.$t('lang.calendario.lun'),
        this.$t('lang.calendario.mar'),
        this.$t('lang.calendario.mie'),
        this.$t('lang.calendario.jue'),
        this.$t('lang.calendario.vie'),
        this.$t('lang.calendario.sab'),
        this.$t('lang.calendario.dom')
      ],
      mesesArray: [
        { mesNum: 1, mesNom: this.$t('lang.calendario.mes1') },
        { mesNum: 2, mesNom: this.$t('lang.calendario.mes2') },
        { mesNum: 3, mesNom: this.$t('lang.calendario.mes3') },
        { mesNum: 4, mesNom: this.$t('lang.calendario.mes4') },
        { mesNum: 5, mesNom: this.$t('lang.calendario.mes5') },
        { mesNum: 6, mesNom: this.$t('lang.calendario.mes6') },
        { mesNum: 7, mesNom: this.$t('lang.calendario.mes7') },
        { mesNum: 8, mesNom: this.$t('lang.calendario.mes8') },
        { mesNum: 9, mesNom: this.$t('lang.calendario.mes9') },
        { mesNum: 10, mesNom: this.$t('lang.calendario.mes10') },
        { mesNum: 11, mesNom: this.$t('lang.calendario.mes11') },
        { mesNum: 12, mesNom: this.$t('lang.calendario.mes12') }
      ],
      tableTitulos: {
        fecha: this.$t('lang.comun.fecha'),
        tipo: this.$t('lang.comun.tipo'),
        hora: this.$t('lang.comun.hora'),
        obs: this.$t('lang.comun.obs'),
        total: this.$t('lang.comun.total'),
        parcial: this.$t('lang.comun.parcial')
      },
      anhosFichajes: [],
      mesesFichajes: [],
      anhoSeleccionado: 0,
      mesSeleccionado: 0,
      semana: '',
      diaInicial: '',
      diaFinal: '',
      diasSemana: [],
      personaJornada: []
    }
  },
  components: {
    BRow,
    BCol
  },
  props: {
    personaParam: Object,
    tabSeleccionado: Number
  },
  created () {
    this.init()
  },
  watch: {
    personaParam: {
      handler (n, o) {
        if (n.mspersonaid !== o.mspersonaid) {
          this.reset(n)
        }
      },
      deep: true
    },
    dateContext: {
      handler (n, o) {
        if (n !== o) {
          this.getDiasSemana()
        }
      }
    }
  },
  methods: {
    init () {
      moment.locale(this.lang)
      this.today = moment()
      this.dateContext = moment()
      this.getDistinctAnhosFichajeByPersonaId()
      this.getDistinctMesesFichajeByAnhoAndPersonaId()
    },
    reset () {
      this.today = moment()
      this.dateContext = moment()
      this.getDistinctAnhosFichajeByPersonaId()
    },
    sumarMes: function () {
      this.dateContext = moment(this.dateContext).add(1, 'month')
    },
    restarMes: function () {
      this.dateContext = moment(this.dateContext).subtract(1, 'month')
    },
    sumarSemana: function () {
      this.dateContext = moment(this.dateContext).add(1, 'w')
      // console.log(this.dateContext.toString())
    },
    restarSemana: function () {
      this.dateContext = moment(this.dateContext).subtract(1, 'w')
      // console.log(this.dateContext.toString())
    },
    getDistinctAnhosFichajeByPersonaId () {
      if (this.personaParam) {
        fichajeApiService.getDistinctAnhosFichajeByPersonaId(this.personaParam.mspersonaid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabFichajesDetalle - getDistinctAnhosFichajeByPersonaId', data.length, 'OK')
            this.anhosFichajes = data
            if (this.anhosFichajes.length > 0) {
              this.anhoSeleccionado = this.anhosFichajes[0]
            }
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabFichajesDetalle - getDistinctAnhosFichajeByPersonaId', error, 'ERROR')
          })
      }
    },
    getDistinctMesesFichajeByAnhoAndPersonaId () {
      if (this.personaParam) {
        fichajeApiService.getDistinctMesesFichajeByAnhoAndPersonaId(this.anhoSeleccionado, this.personaParam.mspersonaid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabFichajesDetalle - getDistinctMesesFichajeByAnhoAndPersonaId', data.length, 'OK')
            this.mesesFichajes = data
            if (this.mesesFichajes.length > 0) {
              this.mesSeleccionado = this.mesesFichajes[0]
            }
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabFichajesDetalle - getDistinctMesesFichajeByAnhoAndPersonaId', error, 'ERROR')
          })
      }
    },
    getFichajeByAnhoMesAndPersonaId () {
      if (this.year && this.personaParam) {
        fichajeApiService.getFichajeByAnhoMesAndPersonaId(this.anhoSeleccionado, this.mesSeleccionado, this.personaParam.mspersonaid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabFichajesDetalle - getFichajeByAnhoMesAndPersonaId', data.length, 'OK')
            this.fichaje = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabFichajesDetalle - getFichajeByAnhoMesAndPersonaId', error, 'ERROR')
          })
      }
    },
    findAllFichajeFilter (fechaInicial, fechaFinal) {
      // fichajeApiService.getFichajeByFechasAndPersonaId(fechaInicial, fechaFinal, this.personaParam.mspersonaid)
      //   .then(data => {
      //     util.mostrarEnConsola('PersonasTabFichajesDetalle - getFichajeByFechasAndPersonaId', data.length, 'OK')
      //     this.fichaje = data
      //   })
      //   .catch(error => {
      //     util.mostrarEnConsola('PersonasTabFichajesDetalle - getFichajeByFechasAndPersonaId', error, 'ERROR')
      //   })
      let filterFichajeList = [
        {
          filterFiltro: true,
          filterTipoFiltro: Const.CONST_FILTER_EQUALS,
          filterCampo: 'MSF_personauid',
          filterValor: this.personaParam.mspersonauid
        },
        {
          filterFiltro: true,
          filterTipoFiltro: Const.CONST_FILTER_GREATEREQUAL,
          filterCampo: 'MSF_fecha',
          filterValor: fechaInicial
        },
        {
          filterFiltro: true,
          filterTipoFiltro: Const.CONST_FILTER_LESSEREQUAL,
          filterCampo: 'MSF_fecha',
          filterValor: fechaFinal
        },
        {
          filterOrderBy: true,
          filterTipoOrderBy: Const.CONST_ASC,
          filterCampo: 'MSF_fecha'
        },
        {
          filterOrderBy: true,
          filterTipoOrderBy: Const.CONST_ASC,
          filterCampo: 'MSF_hora'
        }
      ]
      fichajeApiService.findAllFichajeFilter(filterFichajeList)
        .then(data => {
          if (data) {
            util.mostrarEnConsola('PersonasTabFichajesDetalle - findAllFichajeFilter', `length => ${data.length}`, 'OK')
            this.fichaje = data
          } else {
            util.mostrarEnConsola('PersonasTabFichajesDetalle - findAllFichajeFilter', 'No se han encontrado registros', 'OK')
          }
        })
        .catch(error => {
          util.mostrarEnConsola('PersonasTabFichajesDetalle - findAllFichajeFilter', error, 'ERROR')
        })
    },
    getFichajesDia (dia) {
      let fichajes = []
      if (this.fichaje && this.fichaje.length > 0) {
        let horaAux = ''
        let acumulado = 0
        let tipoFichajeAnterior = 0
        for (let i = 0; i < this.fichaje.length; i++) {
          const fichajeItem = this.fichaje[i]
          if (moment(fichajeItem.msfichajefecha).isSame(dia)) {
            if (fichajeItem.msfichajetipo === 1) { // Entrada
              horaAux = fichajeItem.msfichajehora
            } else { // Salida
              // Comprobamos que el fichaje anterior haya sido entrada
              if (tipoFichajeAnterior === 1) {
                // Restamos a la hora obtenida la hora anterior para obtener el subtotal
                let duracion = moment.duration(moment(fichajeItem.msfichajehora, 'hh:mm').diff(moment(horaAux, 'hh:mm')))
                acumulado += duracion
                fichajeItem.duracionParcial = util.convertirMilisegundoAHoras(duracion, 1)
              }
            }
            // Si es el ultimo fichaje, transformamos el acumulado a hh:mm
            if (i + 1 === this.fichaje.length) { // Ultimo registro
              fichajeItem.duracionTotal = util.convertirMilisegundoAHoras(acumulado, 1)
            } else if (!moment(this.fichaje[i + 1].msfichajefecha).isSame(dia)) { // Cambio de fecha
              fichajeItem.duracionTotal = util.convertirMilisegundoAHoras(acumulado, 1)
            }
            // Guardamos el tipo de fichaje
            tipoFichajeAnterior = fichajeItem.msfichajetipo
            // Cambiamos el formato de la hora
            // fichajeItem.msfichajehora = fichajeItem.msfichajehora.format('H:mm')
            fichajes.push(this.fichaje[i])
          }
        }
      }
      return fichajes
    },
    getDiasSemana () {
      let days = [1, 2, 3, 4, 5, 6, 7].map(d => moment(this.dateContext.format('Y') + '-' + this.dateContext.isoWeek() + '-' + d, 'YYYY-W-E'))
      this.diasSemana = days
      this.findAllFichajeFilter(days[0].format('YYYY-MM-DD'), days[6].format('YYYY-MM-DD'))
    }
  },
  computed: {
    year: function () {
      return this.dateContext.format('Y')
    },
    mes: function () {
      return this.dateContext.format('MM')
    },
    mesSimple: function () {
      return this.dateContext.format('M')
    },
    month: function () {
      if (this.dateContext) {
        return this.dateContext.format('MMMM')
      }
    },
    currentDate: function () {
      return this.dateContext.get('date')
    },
    initialDate: function () {
      return this.today.get('date')
    },
    initialMonth: function () {
      return this.today.format('MMMM')
    },
    initialYear: function () {
      return this.today.format('Y')
    },
    jornada: function () {
      // Recorremos los dias de la semana actual
      let jornada = []
      let count = 0
      for (let d = 0; d < this.diasSemana.length; d++) {
        let diaItem = {
          diaPar: false,
          diaNum: '',
          fichajes: []
        }
        let dia = this.diasSemana[d]
        diaItem.diaNum = dia.format('DD-MM-YYYY')
        // Recogemos los fichajes del dia y los insertamos en el objeto diaItem
        diaItem.fichajes = this.getFichajesDia(dia)
        if (diaItem.fichajes.length > 0) {
          if (count === 0) {
            diaItem.diaPar = true
            count = 1
          } else {
            count = 0
          }
          jornada.push(diaItem)
        }
      }
      return jornada
    }
  }
}
</script>
